import { get } from 'lodash';

export default class CoursePageRatingSettings {
  enabled: boolean;

  constructor(json: any) {
    this.enabled = !!get(json, 'enabled');
  }
}
